<template lang="pug">
    .recruit-table
        table.main
            tr(v-for="row in tableData")
                td.head {{row.name}}
                td.item(v-if="typeOf(row['contents'][0])==='object'")
                    table.sub
                        tr(v-for="item in row.contents")
                            td.head {{item.name}}
                            td.item {{item.contents}}
                td.item(v-if="typeOf(row['contents'][0])!=='object'")
                    ul
                        li(v-for="item in row.contents") {{item}}

</template>
<style lang="scss">
table {
    color: $color-text;
    > tr > td {
        padding: 16px;
        @media #{$phone} {
            padding: 0;
            width: 100%;
            display: block;
        }
    }

    > tr > .head {
        vertical-align: baseline;
    }
}

table.main {
    margin: 55px 0;
    > tr > .head {
        width: 18%;
        font-weight: normal;
        @media #{$phone} {
            width: 100%;
            display: block;
        }
    }

    > tr > .item {
        padding: 16px;
        @media #{$phone} {
            padding: 8px 0;
        }
    }
}

table.sub {
    > tr > .head {
        width: 20%;
        padding: 0;
        @media #{$phone} {
            width: 100%;
            padding-top: 8px;
        }
    }

    > tr > td {
        padding-bottom: 16px;
        padding-top: 0;
        @media #{$phone} {
            padding: 0;
        }
    }

    > tr > .item {
        @media #{$phone} {
            padding: 0;
            padding-bottom: 8px;
            border-bottom: 1.2px solid #e6e6e6;
        }
    }
}
</style>
<script>
export default {
    props: {
        tableData: {
            type: Object,
            required: true
        }
    },
    methods: {
        typeOf(obj) {
            return Object.prototype.toString
                .call(obj)
                .slice(8, -1)
                .toLowerCase();
        }
    }
};
</script>
